import React from 'react';
import { motion } from 'framer-motion';
import { painPoints } from '../data/painPoints';
export function PainPoints() {
  return <section aria-label="Does this sound like you" className="border-y border-gold/30 bg-white/70" data-id="element-110" data-mp="2lmsqcmz6p8ku">
      <div className="mx-auto max-w-4xl px-5 pb-12 pt-10" style={{
      paddingBottom: '8px',
      paddingTop: "11px"
    }} data-id="element-111" data-mp="26xwjgt8v61lt">
        <h2 className="text-center font-display text-[25px] font-black text-plum sm:text-4xl" data-id="element-112" data-mp="2bvo8nfi4j9mb">
          👇 Does this sound like you?
        </h2>
        <div className="mx-auto mt-6 max-w-2xl space-y-3 text-center text-base leading-relaxed text-plum/70" data-id="element-113" data-mp="21zurtjxdgtyq">
          <p data-id="element-114" data-mp="1o0d4za3mzqs0">
            You have a book idea. Maybe you’ve been thinking about it for months. Maybe you’ve already started writing.
            But every time you open your document, you face the same problem:{' '}
            <span className="font-bold text-plum" data-id="element-115" data-mp="3iew89ew05yb3">you don’t know exactly what to write next.</span>
          </p>
          <p data-id="element-116" data-mp="3nbwi80vz3l7h">
            You have ideas — but no structure. Characters — but no clear arcs. Chapters — but no consistent direction.
            And eventually… <span className="font-bold text-plum" data-id="element-117" data-mp="1u23q2l7dexoo">you stop writing.</span>
          </p>
        </div>
        <p className="mx-auto mt-5 max-w-2xl text-center text-lg font-bold text-grape" data-id="element-118" data-mp="27tiamwgxf6xu">
          It’s not a lack of creativity. It’s a lack of a <span className="text-blush" data-id="element-119" data-mp="23rx2fofc7gtz">book-building framework</span>.
        </p>

        <div className="mt-10 grid gap-4 sm:grid-cols-2" data-id="element-120" data-mp="1g2u93jbcbzjn">
          {painPoints.map((p, i) => <motion.div key={p.title} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.3,
          delay: i % 2 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex gap-3 rounded-xl border border-gold/35 bg-cream p-5 sm:last:col-span-2" style={{
          paddingTop: "12px",
          paddingBottom: "12px"
        }} data-id="element-121" data-mp="1b3hoz6but6kr" data-mpi={i}>
              <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-lilac-soft text-sm" aria-hidden="true" data-id="element-122" data-mp="2vknox777xr61">
                {p.emoji}
              </span>
              <div data-id="element-123" data-mp="1y2f05oc8d9kb">
                <h3 className="text-sm font-bold uppercase text-plum" data-id="element-124" data-mp="225tqb7tvv6bh">{p.title}</h3>
                <p className="mt-1 text-sm leading-relaxed text-plum/65" data-id="element-125" data-mp="223qnfn7mtipc">{p.desc}</p>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-126" data-mp="1af71hp9b4yr9">
          <p className="font-display text-2xl font-bold text-plum sm:text-3xl" data-id="element-127" data-mp="1agi5nq6o08iw">
            ✨ If you answered yes, <span className="text-grape" data-id="element-128" data-mp="1ee65n7n7srhn">SIGMA SMART™</span> has the solution.
          </p>
        </div>
      </div>
    </section>;
}